export class MoleculePanelOverviewHeaderMultiDeleteDomainActionComponent {
    public templateUrl = require('./multi-delete-domain-action.html?external');
}
